/** The race's framing note — rendered ONCE near the top, explicitly labeled as
 *  context (not data). Flat and factual; no momentum language. */
export function LensNote({ note, seatContext }: { note?: string; seatContext?: string }) {
  if (!note && !seatContext) return null;
  return (
    <div className="lens">
      {seatContext ? <p className="lens__context">{seatContext}</p> : null}
      {note ? <p className="lens__note">{note}</p> : null}
    </div>
  );
}
